export interface Testimonial {
    id: number;
    testimony: string;
    testifier: string;
  }
  
  export const clientTestimonials: Testimonial[] = [
    {   id: 1, 
        testimony: 'All of my Expectations were not only met, but exceeded', 
        testifier: 'Michelle, Home owner'
    },
    
    {   id: 2, 
        testimony: 'This is the best platform that offers the best of Freelancers', 
        testifier: 'Julian Natallie, Fashionista'
    },

    {   id: 3, 
        testimony: 'I love SendMe and will patronize forever ', 
        testifier: 'Lobeim, Gritton'
    },

    {   id: 4, 
        testimony: 'It worths it, all thanks to SendME', 
        testifier: 'Alabasker, Gardener'
    },



  ];

  export const freelancerTestimonials: Testimonial[] = [
    {   id: 1, 
        testimony: 'Working with SendMe has been a game-changer for my career—constant support and great clients!', 
        testifier: 'Kara D., Graphic Designer'
    },
    
    {   id: 2, 
        testimony: 'I’ve found projects I’m passionate about and clients who appreciate my work. SendMe is the best platform I’ve worked with.', 
        testifier: 'Jordan L., Web Developer'
    },

    {   id: 3, 
        testimony: 'The platform is a perfect fit for freelancers looking to grow—opportunities keep coming!', 
        testifier: 'Samuel R, Photographer'
    },




  ];